<template functional>
  <span
    :class="$options.methods.getClasses(props)"
    v-text="$options.methods.getLabelText(props)"
  />
</template>

<script>
export default {
  name: 'MiaDatatableLabelColumn',

  props: {
    row: {
      type: Object,
      default() {
        return {}
      }
    },

    column: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  methods: {
    getClasses({ row, column }) {
      const defaultClasses = 'px-3 py-1 rounded-full text-center inline-block'

      if (column.meta === undefined || column.meta.labelClasses === undefined) {
        return defaultClasses
      }

      if (typeof column.meta.labelClasses === 'function') {
        return `${defaultClasses} ${column.meta.labelClasses(row)}`
      }

      return `${defaultClasses} ${column.meta.labelClasses}`
    },

    getLabelText({ row, column }) {
      if (column.meta === undefined || column.meta.labelProp === undefined) {
        return row[column.field]
      }

      if (typeof column.meta.labelProp === 'function') {
        return column.meta.labelProp(row)
      }

      if (row[column.meta.labelProp] === undefined) {
        console.error(`[mia-datatable-link-column]: The property "${column.meta.labelProp}" defined as labelProp does not exist on the row object.`)
        return ''
      }

      return row[column.meta.labelProp]
    }
  }
}
</script>
